import { render, staticRenderFns } from "./ClaritySelect.vue?vue&type=template&id=1070b97b&scoped=true&"
import script from "./ClaritySelect.vue?vue&type=script&lang=ts&"
export * from "./ClaritySelect.vue?vue&type=script&lang=ts&"
import style0 from "./ClaritySelect.vue?vue&type=style&index=0&id=1070b97b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1070b97b",
  null
  
)

export default component.exports